module.exports = __webpack_public_path__ + "img/1528148759.3760d5fa.jpg";